import { Button, Grid, MenuItem, Select, TableCell, TableRow, TextField } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RemoveIcon from "@mui/icons-material/Remove";
import * as React from "react";
import { OfferPackCondition } from "./index";

interface ConditionProps {
    index: number;
    entry: OfferPackCondition;

    onUpdate(index: number, item: OfferPackCondition);

    onRemove(index: number);
}

interface ConditionState {
    condition: string;
    operator: string;
    value: string | number;
    secondValue: string | number;
}

export class Condition extends React.Component<ConditionProps, ConditionState> {
    constructor(props: ConditionProps) {
        super(props);

        this.state = {
            condition: this.props.entry.condition,
            operator: this.props.entry.operator,
            value: this.props.entry.value,
            secondValue: this.props.entry.secondValue,
        };
    }

    onValueChange = (key: keyof ConditionState, value: any) => {
        this.setState(state => {
            if (!isNaN(+value)) {
                value = +value;
            }

            // @ts-ignore
            state[key] = value;

            return state;
        }, () => {
            this.props.onUpdate(this.props.index, this.state as OfferPackCondition);
        });
    };

    remove = () => {
        if (!confirm("Are you sure you want to remove this condition?")) {
            return;
        }

        this.props.onRemove(this.props.index);
    };

    render() {
        return <TableRow hover={true}>
            <TableCell>
                <Select value={this.props.entry.condition}
                        fullWidth
                        onChange={(e) => this.onValueChange("condition", e.target.value)}>
                    <MenuItem value={"upgrade_hq"}>upgrade_hq</MenuItem>
                    <MenuItem value={"unlock_special"}>unlock_special</MenuItem>
                    <MenuItem value={"gems"}>gems</MenuItem>
                    <MenuItem value={"league_upgrade"}>league_upgrade</MenuItem>
                    <MenuItem value={"vip_upgrade"}>vip_upgrade</MenuItem>
                    <MenuItem value={"date"}>date</MenuItem>
                    <MenuItem value={"bought_offer"}>bought_offer</MenuItem>
                    <MenuItem value={"mission"}>mission</MenuItem>
                    <MenuItem value={"mm_battles"}>mm_battles</MenuItem>
                </Select>
            </TableCell>

            <TableCell>
                <Select value={this.props.entry.operator}
                        fullWidth
                        onChange={(e) => this.onValueChange("operator", e.target.value)}>
                    <MenuItem value={"=="}>==</MenuItem>
                    <MenuItem value={"!="}>!=</MenuItem>
                    <MenuItem value={">="}>{">="}</MenuItem>
                    <MenuItem value={">"}>{">"}</MenuItem>
                    <MenuItem value={"<="}>{"<="}</MenuItem>
                    <MenuItem value={"<"}>{"<"}</MenuItem>
                    <MenuItem value={"BETWEEN"}>BETWEEN</MenuItem>
                </Select>
            </TableCell>

            <TableCell>
                <Grid container>
                    <Grid item xs={this.props.entry.operator === "BETWEEN" ? 5 : 12}>
                        <TextField value={this.props.entry.value}
                                   onChange={(e) => this.onValueChange("value", e.target.value)}
                                   style={{width: "100%"}}/>
                    </Grid>

                    {this.props.entry.operator === "BETWEEN" && <React.Fragment>
                        <Grid item xs={2} style={{textAlign: "center"}}>
                            <RemoveIcon/>
                        </Grid>
                        <Grid item xs={5}>
                            <TextField value={this.props.entry.secondValue}
                                       onChange={(e) => this.onValueChange("secondValue", e.target.value)}
                                       style={{width: "100%"}}/>
                        </Grid>
                    </React.Fragment>}
                </Grid>
            </TableCell>

            <TableCell>
                <Button disableElevation onClick={this.remove}>
                    <DeleteForeverIcon color={"error"}/>
                </Button>
            </TableCell>
        </TableRow>;
    }
}
